import React from 'react';
import { featuresExplore } from '../components/data';
import "../assests/CSS/FeaturesComponentFour.css";
import { ReactComponent as FeaturesCurve } from "../assests/images/FeaturesCurve.svg";

const FeaturesComponentFour = () => {
  const { title, subtitle, steps } = featuresExplore;

  return (
    <section className='explore-feature-container'>
      <div className="explore-feature-div-1">
        <h2 className="explore-feature-title">{title}</h2>
        <p className="explore-feature-text">{subtitle}</p>
      </div>

      <div className="explore-feature-curve">
        <div className="curve-container">
          <FeaturesCurve className="features-curve-svg" />
          
          <div className="explore-steps-container">
            {steps.map((step, index) => (
              <React.Fragment key={step.id}>
                <div className={`explore-circle explore-circle-${index + 1}`}></div>

                <div className={`explore-step-box explore-step-box-${index + 1}`}>
                  <h3 className="explore-step-head">{step.head}</h3>
                  <h4 className="explore-step-subhead">{step.subhead}</h4>
                  <p className="explore-step-text">{step.text}</p>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesComponentFour;